import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import type { RouteChangeCompleteHandler } from './types';

/**
 * Runs `handler` after a React Router 7 navigation completes, passing the new
 * browser-relative URL (pathname + search + hash). The initial mount is not
 * treated as a navigation.
 */
export const useRouteChangeComplete = (
  handler: RouteChangeCompleteHandler,
  enabled = true,
): void => {
  const location = useLocation();
  const url = `${location.pathname}${location.search}${location.hash}`;

  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  const previousUrl = useRef(url);

  useEffect(() => {
    if (!enabled || previousUrl.current === url) {
      return;
    }
    previousUrl.current = url;
    handlerRef.current(url);
  }, [url, enabled]);
};
